import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import { ClipboardCheck } from '@styled-icons/heroicons-outline/ClipboardCheck'
import { VideoCamera } from '@styled-icons/heroicons-outline/VideoCamera'
import React from 'react'

import { ReactComponent as ChartColumnSvg } from 'assets/vision/ChartColumn.svg'
import { ReactComponent as LayoutListSvg } from 'assets/vision/LayoutList.svg'

/**
 * Icons used by the Vision Review feature that don't have a 1:1 match in
 * `@mui/icons-material`. They're wrapped in MUI `SvgIcon` so the rest of the
 * codebase can treat them like any other MUI icon (theme color, `sx` prop,
 * `fontSize` sizing).
 *
 * Sources:
 *  - ChartColumn / LayoutList → Lucide (see Figma export
 *    `~/Downloads/Hero Vision/src/app/components/layout.tsx`)
 *  - ClipboardCheck / VideoCamera → Heroicons Outline (matches the Figma
 *    silhouette where MUI's clipboard/videocam variants don't)
 */

export const ChartColumnIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon {...props}>
    <ChartColumnSvg />
  </SvgIcon>
)

export const LayoutListIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon {...props}>
    <LayoutListSvg />
  </SvgIcon>
)

export const ClipboardCheckIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon {...props}>
    <ClipboardCheck height="100%" width="100%" />
  </SvgIcon>
)

export const VideoCameraIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon {...props}>
    <VideoCamera height="100%" width="100%" />
  </SvgIcon>
)
